<template>
  <v-app class="layout-auth primary">
    <v-main>
      <v-container class="page-login" fill-height>
        <v-row>
          <v-col>
            <v-card class="modalCard" tile>
              <v-card-title class="modalTitle pt-2 pb-2 mb-2">
                <img
                  class="top-logo"
                  :src="computeLogoIcon"
                  height="50"
                  alt="Turtas"
                />
                <h1 class="primary--text display-1 page-login_title ml-5">
                  Turtas
                </h1>
              </v-card-title>
              <v-card-text>
                <v-card class="mb-2 py-4">
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="12"
                        md="7"
                        class="pt-2 pb-4 pr-8"
                        v-if="showNaudojimas"
                      >
                        <el-byla
                          :byla="naudojimas"
                          color="primary"
                          with-name
                          @openFile="enableNaudojimas()"
                        />
                      </v-col>
                      <v-col cols="12" md="5" class="pb-4">
                        <el-byla
                          :byla="sauga"
                          color="primary"
                          with-name
                          @openFile="enableSauga()"
                        />
                      </v-col>
                    </v-row>
                    <v-divider class="mt-4" />
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        class="pt-6"
                        v-if="showNaudojimas"
                      >
                        <p class="text-inline pa-0 ma-0">
                          <el-checkbox
                            required
                            silent
                            :disabled="disabledNaudojimas"
                            class="mr-5"
                            label="Sutinku su susitarimo dėl testinių hipotekos ir įkeitimo duomenų teikimo sąlygomis"
                            v-model="checkNaudojimas"
                            inline
                          />
                          <el-tooltip
                            sutikimas
                            tooltip="Sutikimas. Susitarimas"
                          />
                        </p>
                        <p
                          :class="
                            `disclaimer text-inline pa-0 ma-0 pl-8 ${
                              disabledNaudojimas ? 'disabled' : ''
                            }`
                          "
                        >
                          Paspausdami „Sutinku“ Jūs su valstybės įmone Registrų
                          centru sudarote Susitarimą dėl testinių hipotekos ir
                          įkeitimo duomenų teikimo Lietuvos Respublikos
                          nekilnojamojo turto ir Sutarčių ir teisių suvaržymų
                          registrų testinėms aplinkoms elektroniniu būdu ir
                          įsipareigojate jo laikytis.
                        </p>
                      </v-col>
                      <v-col cols="12" md="12" class="pt-4">
                        <p class="text-inline pa-0 ma-0">
                          <el-checkbox
                            required
                            silent
                            :disabled="disabledSauga"
                            class="mr-5"
                            label="Sutinku su saugos nuostatais"
                            v-model="checkSauga"
                          />
                          <!-- <el-tooltip
                            sutikimas
                            tooltip="Sutikimas. Saugos nuostatai"
                          /> -->
                        </p>
                        <p
                          :class="
                            `disclaimer text-inline pa-0 ma-0 pl-8 ${
                              disabledSauga ? 'disabled' : ''
                            }`
                          "
                        >
                          {{ saugaTekstas }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card-text>
              <v-card-actions class="modalActions">
                <v-spacer></v-spacer>
                <el-button :loading="loading" @click.native="cancelData()">
                  Atšaukti
                </el-button>
                <el-button
                  :loading="loading"
                  primary
                  @click.native.stop="saveData()"
                >
                  Tęsti
                </el-button>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
export default {
  name: 'PageLogin',
  mixins: [userRole],
  data() {
    return {
      loading: false,
      checkNaudojimas: false,
      checkSauga: false,
      disabledNaudojimas: true,
      disabledSauga: true,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['userID', 'infoTooltips']),

    prefix() {
      return ''
    },
    computeLogoIcon() {
      return '/static/turtas_icon_trans.png'
    },
    naudojimas() {
      return {
        key: 'naudojimo-salygos',
        byl_url: `naudojimo-salygos`,
        byl_pavadinimas:
          'Susitarimas dėl testinių hipotekos ir įkeitimo duomenų teikimo.pdf',
        icon_title:
          'Susitarimas dėl testinių hipotekos ir įkeitimo duomenų teikimo',
      }
    },
    sauga() {
      return {
        key: 'saugos-nuostatai',
        byl_url: `saugos-nuostatai`,
        byl_pavadinimas: 'Saugos nuostatai.pdf',
        icon_title: 'Saugos nuostatai',
      }
    },
    saugaTekstas() {
      let tooltip = this.infoTooltips.find(
        item => item.too_kodas === 'Sutikimas. Saugos nuostatai'
      )
      return tooltip && tooltip.too_tekstas ? tooltip.too_tekstas : ''
    },
    showNaudojimas() {
      return false
    },
  },
  created() {
    if (!this.userID) {
      this.$router.push({ name: 'login' })
    }
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          let data = {
            snau_id: this.userID,
            snau_sutikimas_su_salygomis: true,
          }
          this.$axios
            .post(`naudotojas/sutikimas`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.$store.dispatch('userSutikimas', true).then(() => {
                const gautasPranesimas = sessionStorage.getItem(
                  'gautasPranesimas'
                )
                if (gautasPranesimas && gautasPranesimas.length > 0) {
                  this.$router.push({
                    name: 'pagrindinis',
                  })
                  return
                }
                if (this.roleRGV) {
                  this.$router.push({ name: 'zurnalasGaunami' })
                } else {
                  this.$router.push({ name: 'home' })
                }
              })
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.$store.dispatch('logout').then(() => {
        window._VMA.$emit('SHOW_SNACKBAR', {
          text: 'Atsijungta sėkmingai',
          color: 'success',
        })
        this.$router.push({ name: 'login' })
      })
    },
    enableNaudojimas() {
      this.disabledNaudojimas = false
    },
    enableSauga() {
      this.disabledSauga = false
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-auth {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
}

.modalCard {
  background: #f5f5f5 !important;
  max-width: 700px;
  margin: 0 auto;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}

.disclaimer {
  font-size: 0.8rem;

  &.disabled {
    color: #888888;
  }
}
</style>
